import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { isSFTCabinetsGroup } from '../../../helpers/sqftNavigationHelper';
//import CustomSizeSwitcher from "./Attributes/CustomSizeSwitcher";
//import CustomSize from "./Attributes/CustomSize";
import Handles from "./Attributes/Handles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {FormattedMessage} from "react-intl";
import Hinges from "./Attributes/Hinges";
import workspaceControllers from "../../canvas/store/workspaceControllers";
import workspace from "../../canvas/core/workspace";
import {setFeaturePicker, setSQFTActiveShapeId} from "../../../../../actions/sqftMenuFunctions";
import SectionCustomBox from "./Attributes/SectionCustomBox";
import SectionCustomSize from "./Attributes/SectionCustomSize";
import SectionImage from "./Attributes/SectionImage";
import SectionCabinetInterior from "./Attributes/SectionCabinetInterior";
import OpenDoorsSwitcher from "./Attributes/OpenDoorsSwitcher";
import DoorExtensionSwitcher from "./Attributes/DoorExtensionSwitcher";
import {FEATURES_WITH_DISABLED_RESIZING} from "../../../constants";
import {isShapeTallCabinet} from "../../../helpers/cabinetBoxCompatibilityHelper";
import {is3DMode} from "../NavigationHelper";
import SqftStore from "../../canvas/store/sqftStore";
import {loadCabinetInteriorLayoutForShape} from "../../../helpers/cabinetInteriorLayoutLoader";
//import CabinetPreview from "./Attributes/CabinetPreview";
//import CustomSizeSwapButton from "./Attributes/CustomSizeSwapButton";

const SqftCabinetAttributes = (props) => {
  const {sqftActiveShapeId, setSQFTActiveShapeId, featurePicker, setFeaturePicker} = props;
  const [, setShapeSizeVersion] = useState(0);
  const [, setDoorExtensionVersion] = useState(0);
  const [hasEditableCabinetInterior, setHasEditableCabinetInterior] = useState(false);
  const isCabinet = isSFTCabinetsGroup();
  const shape = workspace.getShapeById(sqftActiveShapeId);
  const isTallCabinet = Boolean(shape && isShapeTallCabinet(shape));
  const cabinetFeatureId = shape && shape.featureId;

  useEffect(() => {
    let cancelled = false;

    setHasEditableCabinetInterior(false);

    if (!isTallCabinet) {
      return undefined;
    }

    const existingLayout = shape.shapeCabinet.getCabinetInteriorLayout();

    // `isEditableInterior` is set only after the GLB parser confirms the
    // Door_Left/Door_Right naming contract. Section types are not a reliable
    // capability check: an editable model may contain doors only, while an old
    // model may coincidentally contain objects named Drawer or Shelf.
    if (existingLayout && existingLayout.isEditableInterior) {
      setHasEditableCabinetInterior(true);
      return undefined;
    }

    // In 2D there is no live Three.js cabinet instance to inspect. For layouts
    // that have not been classified yet, load the model once, parse its section
    // names, and persist the resulting layout on the shape. Subsequent renders
    // use the saved capability flag and do not need this request.
    loadCabinetInteriorLayoutForShape(shape).then((modelLayout) => {
      if (cancelled || !modelLayout) {
        return;
      }

      const currentLayout = shape.shapeCabinet.getCabinetInteriorLayout();
      if (currentLayout && currentLayout.isEditableInterior) {
        setHasEditableCabinetInterior(true);
        return;
      }

      shape.shapeCabinet.setCabinetInteriorLayout(modelLayout);
      setHasEditableCabinetInterior(true);
      SqftStore.updateCalculations();
    });

    return () => {
      cancelled = true;
    };
  }, [shape, isTallCabinet, cabinetFeatureId]);

  if (!isCabinet || !sqftActiveShapeId) {
    if (featurePicker.isOpen) {
      setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
    }
    return null;
  }

  const handleClose = () => {
    setSQFTActiveShapeId(null);
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  };

  const existingHinges = workspaceControllers.hinge.getAllResourcesForTheShape(sqftActiveShapeId);
  if (existingHinges.length) {
    void existingHinges
  }

  const featureName = shape.getFeature()?.getFeatureName();
  const isResizingEnabled = !FEATURES_WITH_DISABLED_RESIZING.includes(featureName);
  const isDoorExtensionEnabled = isTallCabinet && shape.shapeCabinet.getDoorExtensionEnabled();

  const refreshCabinetAttributes = () => {
    setShapeSizeVersion((version) => version + 1);
  };
  const refreshDoorExtensionAttributes = () => {
    setDoorExtensionVersion((version) => version + 1);
  };

  return (
    <div className="sr">
      <div className="sr__header">
        <span className="sr__title">
          <FormattedMessage id="sqft.cabinets.attributes.title"/>
        </span>
        <IconButton aria-label={{}}
                    className="look-icon look-icon--super-tiny look-icon--gray5 sr__close-button"
                    onClick={ handleClose }>
          <CloseIcon className="close-icon"/>
        </IconButton>
      </div>

      <div className="sr__content">
        {/* Original Cabinet Image and Dimensions */}
        <SectionImage shape={shape} />

        {/* Enable Custom Size */}
        { isResizingEnabled ? <SectionCustomSize shape={shape} refreshCabinetAttributes={refreshCabinetAttributes} /> : null }

        { is3DMode() && hasEditableCabinetInterior ? <OpenDoorsSwitcher /> : null }

        { hasEditableCabinetInterior ? (
          <DoorExtensionSwitcher
            shape={shape}
            onChange={refreshDoorExtensionAttributes}
          />
        ) : null }

        {/* Tall Cabinet Interior Layout (sections: boxes, shelves, drawers) */}
        { hasEditableCabinetInterior ? (
          <SectionCabinetInterior
            key={shape.id}
            shape={shape}
            isDoorExtensionEnabled={isDoorExtensionEnabled}
          />
        ) : null }

        {/* Add as custom box */}
        <SectionCustomBox shape={shape} />

        {/* Hinge Selection */}
        <Hinges/>

        {/* Handle Selection */}
        <Handles />

      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
  featurePicker: store.sqftMenuState.featurePicker
});

const mapDispatchToProps = {
  setSQFTActiveShapeId,
  setFeaturePicker
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftCabinetAttributes);
